// extracted by css-extract-rspack-plugin
export default {"root":"root-UvyeSb","rowItem":"rowItem-vqbKLk","svg__wDxJ4":"svg__wDxJ4-Nm4NCW","svgWDxJ4":"svg__wDxJ4-Nm4NCW"};